const SCHEDULED = 'Scheduled'
const DISTRIBUTED = 'Distributed'
const ACTIVE = 'Active'
const EXPIRED = 'Expired'

export default Object.freeze({
    SCHEDULED,
    DISTRIBUTED,
    ACTIVE,
    EXPIRED,
})
